<template>
    <div>
     <!-- <van-nav-bar
        title="联系客服"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/')"
      />-->
      <van-nav-bar
        title="联系客服"
      />
      <iframe id="external-frame" scrolling="no" marginheight=0 marginwidth=0  frameborder="0" width="100%" :height="heigh" :src="server_url" ></iframe>
    </div>
</template>

<script>
    export default {
      name: "ServiceChat",
      data(){
        return{
          heigh:window.innerHeight-100,
          server_url:'',
        }
      },
      methods:{
        // get_server_url(){
        //   let that = this;
        //   that
        //     .$http({
        //       url: "/",
        //       method: "post",
        //       data: {
        //         nozzle: "server_url"
        //       }
        //     })
        //     .then(function(res) {
        //       if (res.data.code == 1) {
        //         var data = res.data.data;
        //         that.server_url = data;
        //       } else if (res.data.code == 0) {
        //         that.$toast.error(res.data.msg);
        //       }
        //     });
        // }
      },
      mounted: function () {
        let heigh = window.innerHeight;
        let user_number = localStorage.getItem("user_number",user_number);
        let chatToken = window.localStorage.chatToken;
        if(this.$store.state.loginType) {
          this.server_url=this.$chatApiURL+'/webclientmobile/index.action?account='+user_number+'&chatToken='+chatToken;
          // console.log("this.ser "+this.server_url)
        } else {
          this.$router.push({ path: 'login', query: { chat: true } })
        }
        // this.get_server_url();
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ServiceChat.vue